var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 80,
    viewBox: "0 0 69 80",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#braveclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.857 19.151l1.876-4.595s-2.388-2.553-5.287-5.447c-2.898-2.894-9.037-1.192-9.037-1.192L46.417 0H21.863L14.87 7.917S8.733 6.215 5.834 9.11a247.223 247.223 0 00-5.286 5.447l1.875 4.595L.036 25.96S7.057 52.505 7.88 55.747c1.62 6.383 2.728 8.851 7.332 12.085 4.604 3.234 12.96 8.851 14.324 9.703 1.364.85 3.07 2.3 4.604 2.3 1.535 0 3.24-1.45 4.604-2.3 1.364-.852 9.72-6.469 14.324-9.703 4.604-3.234 5.712-5.702 7.332-12.085.823-3.242 7.844-29.787 7.844-29.787l-2.387-6.809z",
    fill: "url(#bravepaint0)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.447 12.939s8.993 10.85 8.993 13.17c0 2.32-1.131 2.931-2.269 4.137l-6.742 7.147c-.638.676-1.966 1.701-1.185 3.547.781 1.845 1.933 4.193.652 6.575-1.282 2.381-3.477 3.97-4.884 3.708-1.407-.263-4.71-1.986-5.925-2.774-1.215-.787-5.066-3.957-5.066-5.17s3.98-3.39 4.716-3.885c.735-.495 4.09-2.41 4.158-3.161.069-.752.043-.973-.947-2.83-.99-1.858-2.773-4.336-2.476-5.985.297-1.65 3.172-2.507 5.223-3.28 2.052-.774 6.002-2.234 6.495-2.461.494-.228.366-.444-1.129-.585-1.494-.142-5.736-.704-7.649-.172-1.912.532-5.18 1.342-5.444 1.771-.265.43-.498.444-.226 1.925.272 1.48 1.67 8.586 1.806 9.848.136 1.263.402 2.097-.961 2.408-1.364.311-3.659.851-4.447.851-.789 0-3.084-.54-4.448-.851-1.363-.311-1.097-1.145-.961-2.408.135-1.262 1.535-8.367 1.806-9.848.272-1.481.039-1.496-.226-1.925-.264-.43-3.532-1.239-5.444-1.77-1.913-.533-6.154.03-7.65.17-1.494.142-1.621.358-1.128.586.494.227 4.444 1.687 6.495 2.46 2.052.774 4.927 1.631 5.223 3.28.297 1.65-1.486 4.128-2.475 5.986-.99 1.857-1.017 2.078-.948 2.83.069.751 3.423 2.666 4.159 3.16.735.496 4.715 2.673 4.715 3.886s-3.85 4.383-5.065 5.17c-1.215.788-4.519 2.511-5.926 2.774-1.407.263-3.602-1.327-4.884-3.708-1.281-2.382-.129-4.73.652-6.575.781-1.846-.546-2.87-1.184-3.547l-6.743-7.147c-1.138-1.206-2.269-1.818-2.269-4.137 0-2.32 8.993-13.17 8.993-13.17s7.588 1.447 8.611 1.447c1.023 0 3.24-.851 5.286-1.532 2.047-.681 3.41-.686 3.41-.686s1.365.005 3.411.686c2.046.68 4.263 1.532 5.286 1.532 1.023 0 8.611-1.447 8.611-1.447zm-6.74 41.507c.556.348.216 1.004-.29 1.362-.508.358-7.322 5.625-7.983 6.207-.662.582-1.634 1.544-2.294 1.544-.661 0-1.633-.962-2.294-1.544-.662-.582-7.476-5.85-7.983-6.207-.507-.358-.846-1.014-.29-1.362.557-.347 2.299-1.225 4.702-2.467 2.402-1.24 5.397-2.296 5.865-2.296.467 0 3.462 1.055 5.865 2.296 2.403 1.242 4.144 2.12 4.701 2.467z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "braveMaskA",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 58,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.408 7.917L46.418 0H21.861l-6.991 7.917S8.732 6.215 5.833 9.11c0 0 8.185-.738 10.999 3.83 0 0 7.588 1.447 8.611 1.447 1.023 0 3.24-.851 5.286-1.532 2.047-.681 3.41-.686 3.41-.686s1.365.005 3.411.686c2.046.68 4.263 1.532 5.286 1.532 1.023 0 8.612-1.447 8.612-1.447 2.813-4.568 10.998-3.83 10.998-3.83-2.899-2.894-9.038-1.192-9.038-1.192z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#braveMaskA)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.408 7.917L46.418 0H21.861l-6.991 7.917S8.732 6.215 5.833 9.11c0 0 8.185-.738 10.999 3.83 0 0 7.588 1.447 8.611 1.447 1.023 0 3.24-.851 5.286-1.532 2.047-.681 3.41-.686 3.41-.686s1.365.005 3.411.686c2.046.68 4.263 1.532 5.286 1.532 1.023 0 8.612-1.447 8.612-1.447 2.813-4.568 10.998-3.83 10.998-3.83-2.899-2.894-9.038-1.192-9.038-1.192z",
    fill: "url(#bravepaint1)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bravepaint0",
    x1: 0.0361328,
    y1: 40.4809,
    x2: 68.2441,
    y2: 40.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409877,
    stopColor: "#F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581981,
    stopColor: "#FF2000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bravepaint1",
    x1: 7.04978,
    y1: 7.29426,
    x2: 62.4461,
    y2: 7.29426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF452A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "braveclip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H68.3333V80H0z"
  })))));
};

export default __webpack_public_path__ + "static/media/brave.8abdfcc2.svg";
export { SvgComponent as ReactComponent };